import { Route } from '@angular/router';
import { crmLandingRoute } from './crm-route.helpers';

const INVENTORY_CRUMB = { id: 'inventory', label: 'Inventario' };

export const CRM_INVENTORY_ROUTES: Route[] = [
  crmLandingRoute({
    path: 'inventory/projects/projects',
    moduleId: 'inventory',
    activeMenubarId: 'inv-projects',
    title: 'Proyectos',
    titleBarMode: 'data-table',
    breadcrumbs: [INVENTORY_CRUMB, { id: 'projects', label: 'Proyectos' }],
    loadComponent: () =>
      import('../pages/inventory/projects/projects/projects.component').then(
        (m) => m.ProjectsComponent,
      ),
  }),
  crmLandingRoute({
    path: 'inventory/models/models',
    moduleId: 'inventory',
    activeMenubarId: 'inv-models',
    title: 'Modelos',
    breadcrumbs: [INVENTORY_CRUMB, { id: 'models', label: 'Modelos' }],
    loadComponent: () =>
      import('../pages/inventory/models/models/models.component').then(
        (m) => m.InventoryModelsComponent,
      ),
  }),
  crmLandingRoute({
    path: 'inventory/units/units',
    moduleId: 'inventory',
    activeMenubarId: 'inv-units',
    title: 'Unidades',
    breadcrumbs: [INVENTORY_CRUMB, { id: 'units', label: 'Unidades' }],
    loadComponent: () =>
      import('../pages/inventory/units/units/units.component').then(
        (m) => m.InventoryUnitsComponent,
      ),
  }),
];
